import { boot } from 'quasar/wrappers'
import axios from 'axios'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const isDev = (
  window.location.href.startsWith('http://localhost:8080/') ||
  window.location.href.startsWith('https://localhost:8080/') ||
  window.location.href.startsWith('http://127.0.0.1:3000/') ||
  window.location.href.startsWith('https://127.0.0.1:3000/')
)
const api = axios.create({
  // Produktiv laeuft die API hinter Apache unter /api auf demselben Ursprung.
  // Port 3000 ist von aussen nicht mehr erreichbar.
  baseURL: isDev ? 'https://localhost:3000' : '/api',
  headers: {
    'Content-Type': 'application/json',
    'fdbcache': 'on',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Headers': '*'
  },
  withCredentials: false,
  params: {
    cache: true
  },
})


export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
})

export { api }
